import { BidViewConfig } from '@qv-bid/configs/bid-view-config';

export const STANDARD_VIEW_CONFIG: BidViewConfig = {
  limit: 10,
  buffer: 5,
  scenarioLoadingDebounceInterval: 500,
  scenarioRenderingDebounceInterval: 100,
  scenarioNameUpdateDelayTime: 500
};
